import CategoryCollectionPage from './CategoryCollectionPage';
import { WIECZNE_ROZE_CONFIG } from './categoryPageConfigs';
export default function WieczneRozePage() {
  return <CategoryCollectionPage config={WIECZNE_ROZE_CONFIG} />;
}
